import type { ReactNode } from 'react';
import ReactDOM from 'react-dom';

interface PopupPortalProps {
    children?: ReactNode;
}

const PopupPortal = ({ children }: PopupPortalProps) => {
    if (__isBrowser__) {
        return ReactDOM.createPortal(children, document.body);
    }
    return null;
};
export default PopupPortal;
